const INVOICE_FIELDS = [
    { label: 'Consultation Fee', name: 'consultationFee' },
    { label: 'Lab Investigation Fee', name: 'labInvestigationFee' },
    { label: 'Pharmacy Fee', name: 'pharmacyFee' },
    { label: 'Other Charges', name: 'otherCharges' },
    { label: 'Discount (%)', name: 'discountPercentage' },
];

const getTotal = (invoiceForm) => {
    const total = ['consultationFee', 'labInvestigationFee', 'pharmacyFee', 'otherCharges']
        .reduce((sum, field) => sum + (parseFloat(invoiceForm[field]) || 0), 0);
    const discount = total * ((parseFloat(invoiceForm.discountPercentage) || 0) / 100);
    return (total - discount).toFixed(2);
};

const InvoiceForm = ({ invoiceForm, isSubmittingInvoice, onCancel, onChange, onSubmit, show }) => {
    if (!show) {
        return null;
    }

    return (
        <div className="d-flex justify-content-center my-4">
            <div className="card shadow-sm p-4 w-100" style={{ maxWidth: '600px', borderRadius: '16px', backgroundColor: '#fefefe' }}>
                <h4 className="mb-4 fw-bold text-primary">Generate Invoice</h4>
                <div className="row">
                    {INVOICE_FIELDS.map((field) => (
                        <div className="col-12 mb-3" key={field.name}>
                            <label className="form-label fw-medium" htmlFor={field.name}>{field.label}</label>
                            <input
                                id={field.name}
                                type="number"
                                min="0"
                                name={field.name}
                                className="form-control"
                                placeholder={`Enter ${field.label.toLowerCase()}`}
                                value={invoiceForm[field.name] || ''}
                                onChange={onChange}
                            />
                        </div>
                    ))}
                </div>
                <div className="bg-light rounded p-3 mt-3 mb-2">
                    <h6 className="mb-0 fw-bold text-dark d-flex justify-content-between"><span>Total Amount</span><span>₹{getTotal(invoiceForm)}</span></h6>
                </div>
                <div className="d-flex justify-content-end gap-2 mt-4">
                    <button type="button" className="btn btn-secondary" onClick={onCancel}>Cancel</button>
                    <button type="button" className="btn btn-success" onClick={onSubmit} disabled={isSubmittingInvoice}>
                        {isSubmittingInvoice ? <><span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>Submitting...</> : <><i className="bi bi-file-earmark-plus me-1"></i>Submit Invoice</>}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default InvoiceForm;
